import { internalApiSlice, transformResponse } from "@redux/api/internalApiSlice";
import _ from "lodash";
import { DFS } from "@/types/general";

type DataTransferProcess = {
    operation: "import" | "export" | "price_reconversion";
    module: string;
}

export const dfsApi = internalApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCurrentDataTransferProcess: builder.query<DataTransferProcess, void>({
            query: () => ({
                url: `data-transfer/current`,
                method: "GET"
            }),
            transformResponse
        }),

        getExportableColumns: builder.query<DFS.Operations.Export.Column[], { module: DFS.Operations.Export.Modules }>({
            query: ({ module }) => ({
                url: `data-transfer/export/fields/${module}`,
                method: "GET"
            }),
            transformResponse: (response: { payload: Record<string, string> }) => {
                return _.values(
                    _.mapValues(response.payload, (value, key) => ({
                            key,
                            title: value
                        })
                    )
                );
            }
        }),

        getImportableColumns: builder.query<DFS.Operations.Import.Column[], { module: DFS.Operations.Import.Modules }>({
            query: ({ module }) => ({
                url: `data-transfer/import/fields/${module}`,
                method: "GET"
            }),
            transformResponse: (response: {
                payload: Record<string, { title: string, required: boolean, is_code: boolean }>
            }) => {
                return _.map(response.payload, (value, key) => ({
                    key,
                    title: value.title,
                    required: value.required,
                    is_code: value.is_code
                }));
            }
        })
    })
});

export const extractDataTransferProcess = (data: DataTransferProcess | undefined, operation: DataTransferProcess["operation"]) => {
    if (data && data.operation === operation) {
        return {
            module: data.module
        };
    }
};

export const {
    useGetCurrentDataTransferProcessQuery,
    useGetExportableColumnsQuery,
    useGetImportableColumnsQuery
} = dfsApi;